<mat-form-field appearance="outline" class="multiselect-with-search">
  <mat-select multiple #multiSelect
    (blur)="onTouched(); blur.emit()"
    placeholder="{{placeholder}}"
    (openedChange)="searchControl.setValue('')"
    [disabled]="disabled"
  >
    <app-multiselect-search-input [searchControl]="searchControl"/>

    <mat-divider></mat-divider>

    <div class="options">
      <mat-option
        (click)="$event.stopPropagation()"
        (onSelectionChange)="selectAll($event)"
        [value]="'__select_all__'"
      >
        Select All
      </mat-option>

      <mat-divider></mat-divider>

      <div
        *ngIf="searchControl.value && !multiSelect.options.length"
        class="multiselect-with-search__no-data"
      >
        No results found for "{{searchControl.value}}".
      </div>

      <mat-option
        *ngFor="let option of filteredOptions | async"
        [value]="option.value"
        (onSelectionChange)="onSelectionChange($event)"
      >
        {{option.value}}
      </mat-option>
    </div>
  </mat-select>
</mat-form-field>
